import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Helper } from '@portal/util';

export function uenValidator(control: AbstractControl): ValidationErrors | null {
  const { value } = control;

  if (!value || Helper.isUENNumber(value)) {
    return null;
  }

  return { uen: true };
}
